"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colorLookup = function (color) {
    switch (color) {
        case 'blue':
            return '#1792E5';
        case 'green':
            return '#7EB338';
        case 'yellow':
            return '#FFC627';
        case 'orange':
            return '#F37021';
        case 'red':
            return '#EE3124';
        case 'purple':
            return '#9B59B6';
        case 'lightBlue':
            return '#8BC9F2';
        case 'lightGreen':
            return '#BFD99C';
        case 'lightYellow':
            return '#FFE393';
        case 'lightOrange':
            return '#F9B890';
        case 'lightRed':
            return '#F69791';
        case 'lightPurple':
            return '#CDACDB';
        case 'white':
            return '#ffffff';
        case 'black':
            return '#000000';
        case 'grey':
            return '#404040';
        case 'lightGrey':
            return '#757575';
        default:
            return color;
    }
};
exports.default = colorLookup;
//# sourceMappingURL=ColorLookup.js.map